// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-intl-tel-input {
  --inner-padding-end: 0;
  --padding-start: 0;
  width: 100%;
  display: flex;
  align-items: center;
}
.ion-intl-tel-input.item-interactive-disabled {
  opacity: 1;
}

.ion-intl-tel-input-country {
  min-width: 92px;
  max-width: 120px;
}
.ion-intl-tel-input-country .ionic-selectable-value-item {
  display: none !important;
}
.ion-intl-tel-input-country .ionic-selectable-value {
  display: none !important;
}

.country-name {
  display: inline-block;
  min-width: 160px;
}

.country-dial-code {
  margin-left: 4px;
}

.ion-intl-tel-input-number {
  text-align: right;
  flex: 1;
}
.ion-intl-tel-input-number.input-disabled, .ion-intl-tel-input-number[disabled] {
  opacity: 1;
  --color: #5f6368;
}

.dial-code-display {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px;
  font-size: var(--dial-code-font-size, 16px);
  color: #727272;
  white-space: nowrap;
  min-width: 60px;
}
.dial-code-display .dial-chevron {
  font-size: 12px;
  margin-left: 2px;
  color: var(--ion-color-medium);
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/compat/ion-intl-tel-input/ion-intl-tel-input.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AACF;AAGE;EACE,UAAA;AADJ;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;AAIE;EACE,wBAAA;AAFJ;AAME;EACE,wBAAA;AAJJ;;AAQA;EACE,qBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,iBAAA;EACA,OAAA;AALF;AASE;EAEE,UAAA;EACA,gBAAA;AARJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,2CAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AARF;AAUE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,cAAA;AARJ","sourcesContent":[".ion-intl-tel-input {\n  --inner-padding-end: 0;\n  --padding-start: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  // Ionic auto-dims the whole item once the ion-input inside it is disabled;\n  // keep the row fully legible instead of near-invisible.\n  &.item-interactive-disabled {\n    opacity: 1;\n  }\n}\n\n.ion-intl-tel-input-country {\n  min-width: 92px;\n  max-width: 120px;\n  //  // Hide the default label text that shows \"India +91\"\n  .ionic-selectable-value-item {\n    display: none !important;\n  }\n\n  // Hide inner text of the button\n  .ionic-selectable-value {\n    display: none !important;\n  }\n}\n\n.country-name {\n  display: inline-block;\n  min-width: 160px;\n}\n\n.country-dial-code {\n  margin-left: 4px;\n}\n\n.ion-intl-tel-input-number {\n  text-align: right;\n  flex: 1;\n\n  // Ionic dims disabled inputs to a barely-legible opacity by default; keep the\n  // number readable (in a muted tone that still reads as \"locked\") instead.\n  &.input-disabled,\n  &[disabled] {\n    opacity: 1;\n    --color: #5f6368;\n  }\n}\n.dial-code-display {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0 8px;\n  font-size: var(--dial-code-font-size, 16px);\n  color: #727272;\n  white-space: nowrap;\n  min-width: 60px;\n\n  .dial-chevron {\n    font-size: 12px;\n    margin-left: 2px;\n    color: var(--ion-color-medium);\n    flex: 0 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
